import { render, staticRenderFns } from "./studentRankTopBar.vue?vue&type=template&id=52201534&scoped=true"
import script from "./studentRankTopBar.vue?vue&type=script&lang=js"
export * from "./studentRankTopBar.vue?vue&type=script&lang=js"
import style0 from "./studentRankTopBar.vue?vue&type=style&index=0&id=52201534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52201534",
  null
  
)

export default component.exports